import { useNavigate } from 'react-router-dom';
import Layout from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

export default function EstimationConfirmation() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="min-h-screen bg-[#F5F3EF] flex items-center justify-center px-6">
      <div className="max-w-2xl mx-auto text-center">
        <div className="bg-white rounded-2xl shadow-lg p-12">
          <div className="flex justify-center mb-6">
            <CheckCircle2 className="h-20 w-20 text-[#8A9474]" data-testid="confirmation-icon" />
          </div>

          <h1 className="text-3xl font-bold text-[#2B2B2B] mb-4" data-testid="confirmation-title">
            Votre demande a bien été prise en compte
          </h1>

          <p className="text-lg text-[#4A4A4A] mb-8 leading-relaxed">
            Nous analysons votre bien et revenons vers vous rapidement avec une estimation réaliste de vos revenus locatifs.
          </p>

          <div className="bg-[#F5F3EF] rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-[#2B2B2B] mb-2">Prochaines étapes :</h3>
            <ul className="text-left space-y-2 text-[#4A4A4A]">
              <li>✓ Analyse de votre bien et du marché local</li>
              <li>✓ Calcul du potentiel de revenus</li>
              <li>✓ Un expert vous contactera sous 24-48h</li>
            </ul>
          </div>

          <Button
            onClick={() => navigate('/')}
            className="bg-[#8A9474] hover:bg-[#7A8464] text-white px-8 py-6"
            data-testid="confirmation-home-button"
          >
            Retour à l'accueil
          </Button>

          <p className="text-sm text-[#8B8B8B] mt-6">
            Besoin d'aide ? Contactez-nous à contact@homely.ch
          </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}
